import React, {FC} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {Icon} from 'components/baseIcon/baseIcon';
import * as HelpCenterIcon from 'components/__helpers/icon/svg/common/helpCenter.svg';

import s from './singleLink.scss';

export type PropsType = {
    to: string;
    content: string | React.ReactElement;
    icon: string;
    className: 'grey' | 'bold';
    onClick?: () => void;
};

const ICONS = {
    helpCenter: HelpCenterIcon,
};

/**
 *  Used as stand-alone menu item and has the same styles as Collapse component has, but have no attached sub-items
 *  @param {PropsType} props - Received props
 *  @returns {Node} - Rendered Link stateless component
 */
export const SingleMenuLink: FC<PropsType> = ({
    to,
    content,
    className,
    icon,
    onClick,
}: PropsType) => (
    <Link to={to} className={classNames(s.link, s[className])} onClick={onClick}>
        {content}
        {Boolean(icon) && (
            <div className={s.icon}>
                <Icon icon={ICONS[icon]} />
            </div>
        )}
    </Link>
);
